<template>
  <div class="space-y-4">
    <!-- Empty State -->
    <div v-if="!specifications?.length" class="text-center py-6">
      <p class="text-sm text-gray-500">
        Bu ürün için henüz özellik eklenmemiş.
      </p>
    </div>

    <!-- Specifications Content -->
    <div v-else>
      <!-- Specifications Grid -->
      <div
        class="grid grid-cols-1 md:grid-cols-2 gap-2"
        role="list"
        aria-label="Ürün Özellikleri"
      >
        <div
          v-for="(spec, index) in specifications"
          :key="index"
          class="bg-gray-50 rounded p-3 hover:bg-gray-100/80 transition-colors duration-200"
          role="listitem"
        >
          <div class="flex justify-between items-baseline gap-4">
            <span class="text-xs text-gray-500" :title="spec.attribute_name">
              {{ spec.attribute_name }}
            </span>
            <span
              class="text-sm text-gray-900 font-medium text-right"
              :title="spec.term_name"
            >
              {{ spec.term_name }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const { API_ENDPOINTS } = useApiEndpoints()
const props = defineProps({
  productId: {
    type: Number,
    required: true
  }
})

// Ürün özelliklerini çekme
const { data: specifications, status } = await useAsyncData(
  `product-specifications-${props.productId}`,
  () =>
    useBaseOFetchWithAuth(API_ENDPOINTS.public.products.specifications(props.productId))
)
</script>
